import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthGuard } from './_guards/index-guards';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
// import { SettingComponent } from './setting/setting.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { PublishService, SecurityService, SystemService } from '@app-lib';
import { NgSelectModule } from '@ng-select/ng-select';
import { environment } from '../environments/environment';
import { MainInterceptor } from './_helpers/main.interceptor';
import { InitLocalesForFlatpickrModule } from './_modules/date-picker.module';
import { NavBoxService } from './_services/nav-box.service';
// calendar
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
// importa i global en
import '@angular/common/locales/global/fr';
import '@angular/common/locales/global/it';
import '@angular/common/locales/global/pl';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { HotToastModule } from '@ngneat/hot-toast';
import { TranslocoRootModule } from './_imports/transloco/transloco-root.module';
import { AlertService } from './_services/alert.service';
// import localeIt from '@angular/common/locales/it';

// registerLocaleData(localeIt, 'it');
// registerLocaleData(localeIt);
// registerLocaleData(localeFr);
// registerLocaleData(localePl);
// using lazy loading ...
@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MatDialogModule,
    NgSelectModule,
    ReactiveFormsModule,
    RouterModule,
    TranslocoRootModule,
    HotToastModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    AngularFireModule.initializeApp({
      apiKey: 'AIzaSyDql26WJ2QE97d0nGsU55bGNREsQ2yukTs',
      authDomain: 'diin-digital-inspection-7f29f.firebaseapp.com',
      projectId: 'diin-digital-inspection-7f29f',
      storageBucket: 'diin-digital-inspection-7f29f.appspot.com',
      messagingSenderId: '841398055132',
      appId: '1:841398055132:web:1ccec3876f7ab39e97c419',
    }),
    AngularFireMessagingModule,
    InitLocalesForFlatpickrModule,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'it' },
    { provide: HTTP_INTERCEPTORS, useClass: MainInterceptor, multi: true },
    { provide: 'ENV', useValue: environment },

    AuthGuard,
    NavBoxService,
    PublishService,
    SecurityService,
    SystemService,
    AlertService,

    // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    //  { provide: ErrorHandler, useClass: LocalErrorHandlerService },
    // provider used to create fake backend
    //  fakeBackendProvider
    { provide: LocationStrategy, useClass: HashLocationStrategy },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
